<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app,body,html {
  /*background: url("assets/login/bgc.png") !important;*/
  /*background-color: #FFFFFF !important;*/
}
[v-cloak] {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue